export default __webpack_public_path__ + "static/media/email.e285c67e.svg";